export default "__VITE_ASSET__fe4be915__"